var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.permissions.mainPage)?_c('div',{staticClass:"flex flex-row h-screen"}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }